import React from "react";
import { useNavigate } from "react-router-dom";

const ChestPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .chest-page {
          width: 100%;
          min-height: 100vh;
          background: radial-gradient(circle at top left, #fff1f2 0, #fef2f2 35%, #f3f4f6 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #111827;
        }

        .chest-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .chest-hero {
          display: grid;
          grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
          gap: 24px;
          align-items: center;
          padding: 32px;
          border-radius: 30px;
          background: linear-gradient(120deg, rgba(244, 63, 94, 0.1), rgba(190, 24, 93, 0.05));
          margin-bottom: 40px;
        }

        @media (max-width: 820px) {
          .chest-hero {
            grid-template-columns: 1fr;
          }
        }

        .chest-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 6px 12px;
          border-radius: 999px;
          background: rgba(244, 63, 94, 0.22);
          color: #be123c;
          font-weight: 600;
          text-transform: uppercase;
          font-size: 12px;
          margin-bottom: 10px;
        }

        .chest-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .chest-subtitle {
          font-size: 15px;
          color: #374151;
          max-width: 540px;
          margin-bottom: 14px;
        }

        .chest-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 14px 0 18px;
        }

        .chest-chip {
          padding: 6px 12px;
          background: #111827;
          color: #fff;
          border-radius: 999px;
          font-size: 11px;
        }

        .chest-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 10px;
        }

        .chest-btnPrimary,
        .chest-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 10px 20px;
          cursor: pointer;
          transition: 0.15s ease;
        }

        .chest-btnPrimary {
          background: #e11d48;
          color: #fff;
          box-shadow: 0 10px 24px rgba(225, 29, 72, 0.32);
        }

        .chest-btnPrimary:hover {
          transform: translateY(-2px);
          box-shadow: 0 14px 32px rgba(225, 29, 72, 0.45);
        }

        .chest-btnSecondary {
          background: rgba(0,0,0,0.08);
          border: 1px solid rgba(100,116,139,0.6);
          color: #111827;
        }

        .chest-heroImg {
          width: 100%;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(0,0,0,0.18);
        }

        /* STRIPES */
        .chest-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148,163,184,0.35);
        }

        .chest-sectionTitle {
          font-size: 22px;
          font-weight: 800;
          margin-bottom: 10px;
        }

        .chest-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 20px;
        }

        .chest-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .chest-flexCol {
          flex: 1 1 260px;
        }

        .chest-img {
          width: 100%;
          max-width: 380px;
          border-radius: 22px;
          object-fit: cover;
        }

        /* Cards */
        .chest-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          gap: 20px;
          margin-top: 18px;
        }

        .chest-card {
          padding: 18px;
          background: #fff;
          border-radius: 20px;
          box-shadow: 0 4px 14px rgba(0,0,0,0.06);
        }

        .chest-cardTitle {
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .chest-cardText {
          font-size: 13px;
          color: #4b5563;
        }

        /* Banner */
        .chest-banner {
          margin-top: 24px;
          position: relative;
          border-radius: 26px;
          overflow: hidden;
        }

        .chest-banner img {
          width: 100%;
          height: 250px;
          object-fit: cover;
        }

        .chest-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(0,0,0,0.75), transparent 65%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 20px;
          gap: 10px;
        }

        .chest-bannerText {
          color: #e0e7ff;
          max-width: 420px;
          font-size: 16px;
        }

        .chest-bannerButtons button {
          padding: 8px 14px;
          font-size: 12px;
          border-radius: 999px;
          cursor: pointer;
          border: none;
        }

        .primary {
          background: #16a34a;
          color: #022c22;
        }

        .secondary {
          background: rgba(255,255,255,0.18);
          color: white;
          border: 1px solid rgba(255,255,255,0.55);
        }

      `}</style>

      <div className="chest-page">
        <div className="chest-inner">

          {/* HERO */}
          <section className="chest-hero">
            <div>
              <div className="chest-tag">
                <span className="chest-tag-dot"></span> Chest Relief
              </div>

              <h1 className="chest-title">
                Reduce chest tightness so breathing, lifting, and posture feel natural again.
              </h1>

              <p className="chest-subtitle">
                The pectoralis major and minor affect breathing mechanics, shoulder movement, and posture. When tight or irritated, they can pull the shoulder forward and create sharp or aching chest sensations.
              </p>

              <div className="chest-chips">
                <span className="chest-chip">Chest tightness</span>
                <span className="chest-chip">Pulling sensation</span>
                <span className="chest-chip">Posture strain</span>
                <span className="chest-chip">Breathing stiffness</span>
              </div>

              <div className="chest-ctaRow">
                <button className="chest-btnPrimary" onClick={() => navigate("/appointments")}>
                  Book chest session →
                </button>
                <button className="chest-btnSecondary" onClick={() => navigate("/staff")}>
                  Meet therapists
                </button>
              </div>
            </div>

            <img
              src="/content/chest/chest_hero.jpg"
              className="chest-heroImg"
              alt="Therapist working with patient's chest and shoulder area"
            />
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="chest-stripe">
            <h2 className="chest-sectionTitle">What can go wrong in the chest?</h2>
            <p className="chest-sectionSubtitle">
              Chest muscles help move the arm, support posture, and assist breathing. Irritation can cause surprising symptoms.
            </p>

            <div className="chest-flexRow">
              <div className="chest-flexCol">
                <ul style={{ listStyle: "none", padding: 0, display: "grid", gap: "8px" }}>
                  <li>• Tight pec minor pulling shoulders into forward posture</li>
                  <li>• Pec major strain from lifting or pushing</li>
                  <li>• Deep chest tightness from breathing mechanics</li>
                  <li>• Tender spots from workouts or poor posture</li>
                  <li>• Pain radiating toward the shoulder or arm</li>
                </ul>

                <div className="chest-ctaRow" style={{ marginTop: "14px" }}>
                  <button className="chest-btnPrimary" onClick={() => navigate("/appointments")}>
                    Check your chest symptoms →
                  </button>
                </div>
              </div>

              <div className="chest-flexCol" style={{ textAlign: "center" }}>
                <img
                  src="/content/chest/chest_pecmajor.jpg"
                  className="chest-img"
                  alt="Therapist working on pectoralis major"
                />
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="chest-stripe">
            <div className="chest-flexRow">
              <div className="chest-flexCol">
                <img
                  src="/content/chest/chest_manual.jpg"
                  className="chest-img"
                  alt="Manual therapy for chest muscles"
                />
              </div>

              <div className="chest-flexCol">
                <h2 className="chest-sectionTitle">How physical therapy helps your chest</h2>

                <ul style={{ listStyle: "none", padding: 0, display: "grid", gap: "8px" }}>
                  <li>• Soft-tissue work to pec major/minor</li>
                  <li>• Postural strengthening to open the chest</li>
                  <li>• Gentle chest stretching that actually works</li>
                  <li>• Shoulder mechanics retraining</li>
                  <li>• Breathing drills to reduce rib stiffness</li>
                </ul>

                <div className="chest-ctaRow" style={{ marginTop: "14px" }}>
                  <button className="chest-btnPrimary" onClick={() => navigate("/appointments")}>
                    Start chest therapy →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* CARDS */}
          <section className="chest-stripe">
            <h2 className="chest-sectionTitle">Chest areas we help</h2>

            <div className="chest-cardGrid">
              <div className="chest-card">
                <div className="chest-cardTitle">Pectoralis Major</div>
                <div className="chest-cardText">Helps move the arm; often strained with lifting or pushing.</div>
              </div>

              <div className="chest-card">
                <div className="chest-cardTitle">Pectoralis Minor</div>
                <div className="chest-cardText">Deep chest muscle tied to posture and breathing mechanics.</div>
              </div>

              <div className="chest-card">
                <div className="chest-cardTitle">Sternal / Clavicular Region</div>
                <div className="chest-cardText">Can feel tight with slouched posture or heavy lifting.</div>
              </div>
            </div>
          </section>

          {/* VISIT FLOW */}
          <section className="chest-stripe">
            <h2 className="chest-sectionTitle">What a chest session looks like</h2>

            <div className="chest-flexRow">
              <div className="chest-flexCol">
                <img
                  src="/content/chest/chest_exercises.jpg"
                  className="chest-img"
                  alt="Chest strengthening and stretching exercises"
                />
              </div>

              <div className="chest-flexCol">
                <div className="wrist-timeline">
                  <div className="wrist-step">
                    <div className="wrist-stepLabel">1. Your story</div>
                    <div className="wrist-stepText">Where does it feel tight? What movements bring it on?</div>
                  </div>

                  <div className="wrist-step">
                    <div className="wrist-stepLabel">2. Mobility check</div>
                    <div className="wrist-stepText">Chest motion, shoulder mechanics, breathing.</div>
                  </div>

                  <div className="wrist-step">
                    <div className="wrist-stepLabel">3. Hands-on care</div>
                    <div className="wrist-stepText">Targeted pec work, joint mobility, posture reset.</div>
                  </div>

                  <div className="wrist-step">
                    <div className="wrist-stepLabel">4. Home plan</div>
                    <div className="wrist-stepText">A few key stretches + posture cues tailored to you.</div>
                  </div>
                </div>

                <div className="chest-ctaRow" style={{ marginTop: "14px" }}>
                  <button className="chest-btnPrimary" onClick={() => navigate("/appointments")}>
                    Book evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="chest-stripe">
            <div className="chest-banner">
              <img src="/content/chest/chest_banner.png" alt="Calm therapy environment for chest treatment" />

              <div className="chest-bannerOverlay">
                <div className="chest-bannerText">
                  Chest sessions take place in a quiet, supportive space designed for comfort and recovery.
                </div>

                <div className="chest-bannerButtons">
                  <button className="primary" onClick={() => navigate("/appointments")}>
                    Schedule visit →
                  </button>

                  <button className="secondary" onClick={() => navigate("/office")}>
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default ChestPT;
